"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _presentationUtils = require("@ori/presentation-utils");
var _common = require("../../common");
var _ImagePlaceholder = require("../ImagePlaceholder");
var _LazyImage = require("../LazyImage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const getTransitionBoxSrcSet = (theme, imageUrl) => {
  const imagesVariants = {
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: _styles.PRODUCT_IMAGE_DESKTOP_WIDTH,
      quality: 90
    }, {
      width: theme.breakpoints.values.sm,
      quality: 90
    }]
  };
  return (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants));
};
const getOfferBundleBoxSrcSet = (theme, imageUrl) => {
  const imagesVariants = {
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageSizeMultiplier: 2,
    params: [{
      width: _styles.BUNDLE_IMAGE_DESKTOP_SIZE,
      quality: 90
    }, {
      width: _styles.BUNDLE_IMAGE_MOBILE_SIZE,
      quality: 90
    }]
  };
  return (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants));
};
const Image = ({
  productImageUrls
}) => {
  const theme = (0, _mui.useTheme)();
  if (productImageUrls && productImageUrls.length > 1) {
    const rows = (0, _presentationUtils.chunkArray)(productImageUrls, 4);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImages, {
      "data-testid": _common.PRODUCT_TILE_BUNDLES_IMAGES,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImagesInner, {
        children: rows.map(imageUrls => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImagesRow, {
          children: imageUrls.map(imageUrl => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImage, {
            alt: imageUrl,
            sizes: `(max-width: ${theme.breakpoints.values.sm - 1}px) ${_styles.BUNDLE_IMAGE_MOBILE_SIZE}px, ${_styles.BUNDLE_IMAGE_DESKTOP_SIZE}px`,
            srcSet: getOfferBundleBoxSrcSet(theme, imageUrl)
          }, imageUrl))
        }, JSON.stringify(imageUrls)))
      })
    });
  }
  const imageUrl = productImageUrls?.[0];
  if (imageUrl) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
      alt: productImageUrls[0],
      sizes: `(max-width: ${theme.breakpoints.values.sm - 1}px) ${theme.breakpoints.values.sm}px, ${_styles.PRODUCT_IMAGE_DESKTOP_WIDTH}px`,
      srcSet: getTransitionBoxSrcSet(theme, imageUrl)
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePlaceholder.ImagePlaceholder, {});
};
exports.Image = Image;
